// extracted by mini-css-extract-plugin
export default {"display":"_QMxYV","device":"_13xh6m","loading":"EWw4SL","skeleton":"pqPjOm","iframe":"l1EiyS","skeletonGroup":"trLo0H"};